import { useEventPowerDialerUpdated } from 'entities/PowerDialer/events/EventPowerDialerUpdated'
import type { PowerDialerViewStore } from 'pages/powerDialer/pages/view/store/powerDialerViewStore'

export const useEventViewPowerDialerUpdated = (store: PowerDialerViewStore) => {
  const { updatePowerDialerViewItem } = store

  useEventPowerDialerUpdated((powerDialerResponse) => {
    if (
      store.powerDialer?.id === powerDialerResponse.id &&
      store.powerDialer?.lastRefreshed !== powerDialerResponse.last_refreshed
    ) {
      updatePowerDialerViewItem(powerDialerResponse)
    }
  })
}
